import type { ElementPatch, LineElement } from '@/components/canvas/document/publicTypes';

/** 线段手柄拖拽 / 落盘：layout + size + data.start/end（起点固定为 0,0） */
export function lineGeometryToPatch(
  x: number,
  y: number,
  endX: number,
  endY: number,
  width: number,
  height: number,
): ElementPatch<'line'> {
  return {
    layout: { x, y },
    size: { width, height },
    data: { start: { x: 0, y: 0 }, end: { x: endX, y: endY } },
  };
}

export function getLineEndOffset(line: LineElement): { endX: number; endY: number } {
  const start = line.data.start ?? { x: 0, y: 0 };
  const end = line.data.end ?? { x: line.size.width, y: 0 };
  return { endX: end.x - start.x, endY: end.y - start.y };
}

export function getLineChromeRect(
  line: LineElement,
  offset: { dx: number; dy: number } = { dx: 0, dy: 0 },
): { x: number; y: number; width: number; height: number } {
  const { endX, endY } = getLineEndOffset(line);
  return {
    x: line.layout.x + Math.min(0, endX) + offset.dx,
    y: line.layout.y + Math.min(0, endY) + offset.dy,
    width: Math.max(1, Math.abs(endX)),
    height: Math.max(1, Math.abs(endY)),
  };
}
